// extracted by mini-css-extract-plugin
module.exports = {"label":"ePKMidwUWfH9","disabled":"_23Vk8h3D_gWl"};